import { useEffect, useState } from "react";
import { doc, onSnapshot, setDoc } from "firebase/firestore";
import { firestore } from "../../../helpers/firebaseConfig";

const DEFAULT_PERMISSIONS = { hazardLayer: true, fetchData: true };

export default function useBuilderSettings(simulationId) {
  const [permissions, setPermissions] = useState(DEFAULT_PERMISSIONS);
  const [savingKey, setSavingKey] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!simulationId) return undefined;
    return onSnapshot(doc(firestore, "model_builders", simulationId), (snapshot) => {
      const saved = snapshot.data()?.settings?.permissions || {};
      setPermissions({
        hazardLayer: saved.hazardLayer !== false && saved.hazardConfig !== false,
        fetchData: saved.fetchData !== false,
      });
      setError("");
    }, (snapshotError) => {
      setError(`Could not load settings: ${String(snapshotError?.message || snapshotError)}`);
    });
  }, [simulationId]);

  const changePermission = async (key, enabled) => {
    if (!simulationId || !["hazardLayer", "fetchData"].includes(key)) return;
    setSavingKey(key);
    setError("");
    try {
      await setDoc(doc(firestore, "model_builders", simulationId), {
        settings: { permissions: key === "hazardLayer"
          ? { hazardLayer: Boolean(enabled), hazardConfig: Boolean(enabled) }
          : { fetchData: Boolean(enabled) } },
      }, { merge: true });
    } catch (saveError) {
      setError(`Could not save settings: ${String(saveError?.message || saveError)}`);
    } finally {
      setSavingKey("");
    }
  };

  return { permissions, savingKey, error, changePermission };
}
